import { HttpErrorResponse } from '@angular/common/http';

/** Paths where Node returns 207/422 as business envelopes (FR-CCV-UI-008). */
const CUSTOMS_CITY_CLEARANCE_BUSINESS_HTTP_PATHS = [
  '/customsCity/processClearance',
  '/customsCity/validateClearanceSelection',
  '/customsCity/validateCustomsCityClearance',
] as const;

/** Body statusCode values that mean "handled by caller, not global toast". */
const CUSTOMS_CITY_CLEARANCE_BUSINESS_BODY_STATUS_CODES = new Set<number>([
  207, // PartialQueued / PartialEligible
  422, // NoneQueued / NoneEligible
]);

function hasCustomsCityBusinessBodyStatusCode(payload: unknown): boolean {
  if (!payload || typeof payload !== 'object') {
    return false;
  }
  const statusCode = (payload as { statusCode?: unknown }).statusCode;
  return (
    typeof statusCode === 'number' &&
    CUSTOMS_CITY_CLEARANCE_BUSINESS_BODY_STATUS_CODES.has(statusCode)
  );
}

/** Suppress interceptor generic snackbar for Customs City business 207/422. */
export function isCustomsCityProcessClearanceBusinessHttpError(
  error: HttpErrorResponse
): boolean {
  if (error.status !== 207 && error.status !== 422) {
    return false;
  }
  const url = error.url ?? '';
  if (
    !CUSTOMS_CITY_CLEARANCE_BUSINESS_HTTP_PATHS.some(path => url.includes(path))
  ) {
    return false;
  }
  return hasCustomsCityBusinessBodyStatusCode(error.error);
}
